__webpack_require__.p = "/my-gpt/";